export const selectSummaryData = (state) => state.samplingTrackingSummary?.summaryData;
export const selectLoading = (state) => state.samplingTrackingSummary?.loading;
